<template>
  <div class="popup" @touchmove.stop.prevent>
    <transition name="fade">
      <div class="popup-overlay" @click="clickMask" v-show="visible"></div>
    </transition>
    <transition name="fade">
      <div class="popup-main" v-show="visible">
        <div class="popup-content">
          <slot></slot>
        </div>
        <div class="button-wrap">
          <span @click="clickMask">确认</span>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  props: {
    visible: Boolean
  },
  methods: {
    clickMask() {
      this.$emit('update:visible', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.popup {
  .popup-overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    widows: 100vw;
    background: rgba(var(--font-color-1-rgb), 0.3);
    z-index: 9999;
  }
  .popup-main {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 80%;
    transform: translate3d(-50%, -50%, 0);
    background: var(--bg-color-2);
    border-radius: 10px;
    z-index: 9999;
    overflow: hidden;
    text-align: center;
  }
  .popup-content {
    padding: 15px;
    color: var(--font-color-3);
  }
  .button-wrap {
    padding: 10px 0;
    font-weight: bold;
    font-size: 14px;
    color: var(--main-color-1);
  }
}
</style>
